module.exports = class Modal {

    constructor() {

        this.xhr = new XMLHttpRequest();
        this.container = (() => {

            let container = document.createElement("section"),
                content = document.createElement("div"),
                button = document.createElement("button");

            button.setAttribute("type", "button");

            button.addEventListener("click", this.Close.bind(this));

            content.classList.add("content");

            container.classList.add("modal");

            container.appendChild(button);
            container.appendChild(content);

            container.addEventListener("transitionend", (event) => {

                if (event.target === this.container) {

                    if (this.container.dataset.status == 4) {

                        document.body.dataset.overflow = 1;
                        container.dataset.content      = 1;

                    }

                    if (this.container.dataset.status == 5) {

                        this.container.parentElement.removeChild(this.container);

                    }
                    
                }

            });

            return container;

        })();

        document.addEventListener("keydown", (event) => {

            if (event.keyCode == 27) {

                this.Close();

            }

        });
    }

    /**
    * @param {string} uri The URI you want to call using the X-Ajax-Modal header
    * @param {string} identifier The "for" attribute you want to set the modal markup
    * @param {number} index The index for the color rubric
    */
    Open(uri, identifier, index) {

        this.xhr.abort();
        this.xhr.open("GET", uri, true);
        this.xhr.setRequestHeader("X-Ajax-Modal", "1");
        this.xhr.setRequestHeader("Accept", "text/html");

        document.body.appendChild(this.container);
        document.body.dataset.modalOrigin = window.location.href;
        document.body.dataset.modalUri = uri;

        this.container.dataset.status = 0;

        this.container.setAttribute("for", identifier || "no-identifier");

        this.xhr.onreadystatechange = () => {

            document.body.dataset.modal = document.body.dataset.modal || 1;

            this.container.dataset.status = this.xhr.readyState;
            this.container.dataset.index = index;

            if (this.xhr.readyState === XMLHttpRequest.DONE) {

                if (this.xhr.status === 200) {

                    history.replaceState({}, "", uri);

                    this.container.querySelector('div').innerHTML = this.xhr.responseText;


                } else {

                    window.location.href = uri;

                }
            }
        }

        this.xhr.send();

    }

    Close() {

        delete document.body.dataset.overflow;
        delete this.container.dataset.content;

        history.replaceState({}, "", document.body.dataset.modalOrigin);

        this.container.dataset.status = 5;

        delete document.body.dataset.modal;
        delete document.body.dataset.modalOrigin;

        document.body.querySelector("[href='" + document.body.dataset.modalUri + "']").scrollIntoView({
            behavior: "smooth",
            block: "center"
        });

        delete document.body.dataset.modalUri;

    }
}